module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tabs is-boxed"
  }, [_c('ul', [_c('li', {
    class: {
      'is-active': _vm.tabUserActive
    },
    on: {
      "click": function($event) {
        _vm.toggle('user')
      }
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.tabModActive
    },
    on: {
      "click": function($event) {
        _vm.toggle('mod')
      }
    }
  }, [_vm._m(2)]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.tabGamesActive
    },
    on: {
      "click": function($event) {
        _vm.toggle('games')
      }
    }
  }, [_vm._m(3)]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.tabLeaderboardActive
    },
    on: {
      "click": function($event) {
        _vm.toggle('leaderboard')
      }
    }
  }, [_vm._m(4)])])]), _vm._v(" "), (_vm.tabUserActive) ? _c('div', [_c('table', {
    staticClass: "table is-striped"
  }, [_vm._m(5), _vm._v(" "), _c('tbody', _vm._l((_vm.userCommands), function(command) {
    return _c('tr', [_c('td', {
      domProps: {
        "innerHTML": _vm._s(command.c)
      }
    }), _vm._v(" "), _c('td', {
      domProps: {
        "innerHTML": _vm._s(command.d)
      }
    })])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.tabModActive) ? _c('div', [_c('table', {
    staticClass: "table is-striped"
  }, [_vm._m(6), _vm._v(" "), _c('tbody', _vm._l((_vm.modCommands), function(command) {
    return _c('tr', [_c('td', {
      domProps: {
        "innerHTML": _vm._s(command.c)
      }
    }), _vm._v(" "), _c('td', {
      domProps: {
        "innerHTML": _vm._s(command.d)
      }
    })])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.tabGamesActive) ? _c('div', [_c('div', {
    staticClass: "box"
  }, [_vm._m(7), _vm._v(" "), _c('p', [_vm._v("ChillCoins™ is a unique way to reward our users and provides them with a way of showing their appreciation for spinning super dope tracks. The hope is that this feature will elevate room morale and provide users with incentive to help make the community vibe even more chill than it already is (sub-zero?). Some basic rules are as follows: ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('blockquote', [_c('ul', [_c('li', [_vm._v("Everyone can earn ChillCoins™")]), _vm._v(" "), _c('li', [_vm._v("Anyone can give ChillCoins™")]), _vm._v(" "), _c('li', [_vm._v("Anyone can buy perks with ChillCoins™")])])]), _vm._v(" "), _c('blockquote', [_c('ul', [_c('li', [_c('strong', [_vm._v("Staff")]), _vm._v(" may award ChillCoins™ to anyone:")]), _vm._v(" "), _c('li', [_vm._v("When awarding non-staff: ChillCoins™ come from the bottomless coffers of the Chillout Music Bank.")]), _vm._v(" "), _c('li', [_vm._v("When awarding other staff members: ChillCoins™ come from the tipper's own wallet.")])])]), _vm._v(" "), _c('blockquote', [_c('ul', [_c('li', [_c('strong', [_vm._v("Non-Staff Users")]), _vm._v(" may use ChillCoins™ from their wallet to:")]), _vm._v(" "), _c('li', [_vm._v("Exchange coins for perks while on the Wait List to move up a space or even all the way to the front.")]), _vm._v(" "), _c('li', [_vm._v("Tip their homies.")]), _vm._v(" "), _c('li', [_vm._v("Trade Wait List spot with their homies.")])])]), _vm._v(" "), _c('table', {
    staticClass: "table is-striped"
  }, [_vm._m(8), _vm._v(" "), _c('tbody', _vm._l((_vm.chillcoinCommands), function(command) {
    return _c('tr', [_c('td', {
      domProps: {
        "innerHTML": _vm._s(command.c)
      }
    }), _vm._v(" "), _c('td', {
      domProps: {
        "innerHTML": _vm._s(command.d)
      }
    })])
  }))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_vm._m(9), _vm._v(" "), _c('p', [_vm._v("Love is a feature where our users can show appreciation to others in the room. Users can send \"Points\" to other users for any reason they want! After a day, a winner is declared and will benefit from a Wait List Boost and free ChillCoins. We hope that this brings the community closer in a interactive and fun way. Check the "), _c('a', {
    on: {
      "click": function($event) {
        _vm.toggle('leaderboard')
      }
    }
  }, [_vm._v("leaderboard here!")])]), _vm._v(" "), _c('table', {
    staticClass: "table is-striped"
  }, [_vm._m(10), _vm._v(" "), _c('tbody', _vm._l((_vm.loveCommands), function(command) {
    return _c('tr', [_c('td', {
      domProps: {
        "innerHTML": _vm._s(command.c)
      }
    }), _vm._v(" "), _c('td', {
      domProps: {
        "innerHTML": _vm._s(command.d)
      }
    })])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('blockquote', [_c('ul', [_c('li', [_c('strong', [_vm._v("Rewards:")])]), _vm._v(" "), _c('li', [_vm._v("!love = 0.15 point for source user, 1 for target user")]), _vm._v(" "), _c('li', [_vm._v("!tip = 0.50 for source non-staff user, 1 point for non-staff target user")]), _vm._v(" "), _c('li', [_vm._v("grabs = 0.25 points for each grab, minimum 3 grabs")]), _vm._v(" "), _c('li', [_vm._v("raffle = 1 point for winner")]), _vm._v(" "), _c('li', [_vm._v("trivia = 1 point for winner")]), _vm._v(" "), _c('li', [_vm._v("One prize (every 24 hours): Wait List Boost, which pushes the user 2 thirds of the way up the waitlist and 3 ChillCoins.")]), _vm._v(" "), _c('li', [_vm._v("* Users can accumulate boost and use it at their time of choosing.")])])])], 1)]), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12)]) : _vm._e(), _vm._v(" "), (_vm.tabLeaderboardActive) ? _c('div', [_c('div', {
    staticClass: "box"
  }, [_vm._m(13), _vm._v(" "), _c('p', [_vm._v("Leaderboard has been reset "), _c('strong', [_vm._v(_vm._s(_vm.leaderboard.started))]), _vm._v(" and will end "), _c('strong', [_vm._v(_vm._s(_vm.leaderboard.ends))]), _vm._v(". Watch this space! Winners can type "), _c('strong', [_vm._v("!use boost")]), _vm._v(" in our Plug.dj room to use the free boost and get free ChillCoins.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table is-striped"
  }, [_vm._m(14), _vm._v(" "), _c('tbody', _vm._l((_vm.leaderboard.participants), function(participant) {
    return _c('tr', [_c('td', {
      domProps: {
        "innerHTML": _vm._s(participant.username)
      }
    }), _vm._v(" "), _c('td', {
      domProps: {
        "innerHTML": _vm._s(participant.points_received)
      }
    }), _vm._v(" "), _c('td', _vm._l((participant.awards_received), function(award) {
      return _c('span', [_vm._v(_vm._s(award.username) + " (" + _vm._s(award.points_sent) + ") ")])
    }))])
  }))])])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero page-bot"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container page-header"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-third"
  }, [_c('h1', {
    staticClass: "title",
    staticStyle: {
      "color": "#000"
    }
  }, [_c('span', {
    staticClass: "icon is-large"
  }, [_c('i', {
    staticClass: "fa fa-cogs"
  })]), _vm._v(" Bot")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("\n              ChilloutRoomba - the artificial intelligence serving cat pictures and banhammers.\n            ")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('span', [_vm._v("User Commands")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('span', [_vm._v("Mod Commands")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('span', [_vm._v("Games")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('span', [_vm._v("Leaderboard")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "column-keyword"
  }, [_vm._v("Command")]), _vm._v(" "), _c('th', {
    staticClass: "column-content"
  }, [_vm._v("Description")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "column-keyword"
  }, [_vm._v("Command")]), _vm._v(" "), _c('th', {
    staticClass: "column-content"
  }, [_vm._v("Description")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title is-3",
    staticStyle: {
      "color": "#000"
    }
  }, [_c('span', {
    staticClass: "icon is-large",
    staticStyle: {
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-usd"
  })]), _vm._v("ChillCoin™")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "column-keyword"
  }, [_vm._v("Command")]), _vm._v(" "), _c('th', {
    staticClass: "column-content"
  }, [_vm._v("Description")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title is-3",
    staticStyle: {
      "color": "#000"
    }
  }, [_c('span', {
    staticClass: "icon is-large",
    staticStyle: {
      "color": "red"
    }
  }, [_c('i', {
    staticClass: "fa fa-heart"
  })]), _vm._v(" Love")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "column-keyword"
  }, [_vm._v("Command")]), _vm._v(" "), _c('th', {
    staticClass: "column-content"
  }, [_vm._v("Description")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "title is-3",
    staticStyle: {
      "color": "#000"
    }
  }, [_c('span', {
    staticClass: "icon is-large",
    staticStyle: {
      "color": "#BBB"
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-numeric-desc"
  })]), _vm._v("Raffle")]), _vm._v(" "), _c('p', [_vm._v("Raffle, which occurs every 30 minutes, provides a significant Wait List Boost to the winners. If you are already in position #1, you will need to lock your spot by typing "), _c('strong', [_vm._v("!join")]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": "/img/raffle_01.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "title is-3",
    staticStyle: {
      "color": "#000"
    }
  }, [_c('span', {
    staticClass: "icon is-large",
    staticStyle: {
      "color": "orange"
    }
  }, [_c('i', {
    staticClass: "fa fa-question"
  })]), _vm._v("Trivia")]), _vm._v(" "), _c('p', [_vm._v("Trivia is a fun game to test your knowledge on various topics, provides a small Wait List Boost. Held every 3 hours. Each correct response will need to be preceded by "), _c('strong', [_vm._v("!a")]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": "/img/trivia_01.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title is-3",
    staticStyle: {
      "color": "#000"
    }
  }, [_c('span', {
    staticClass: "icon is-large",
    staticStyle: {
      "color": "red"
    }
  }, [_c('i', {
    staticClass: "fa fa-heart"
  })]), _vm._v(" Leaderboard")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "column-keyword"
  }, [_vm._v("Username")]), _vm._v(" "), _c('th', {
    staticClass: "column-content"
  }, [_vm._v("Points")]), _vm._v(" "), _c('th', {
    staticClass: "column-content"
  }, [_vm._v("Lovers")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b0135fd4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Bot.vue
// module id = 172
// module chunks = 1